import React from 'react';
import CommonRadioForm from './CommonRadioForm';
import { firstSevenResources, secondSevenResources, thirdSevenResources } from '../../common/constant/data';
import { useTranslation } from "react-i18next";
const ResourcesFormOne = ({ formik, renderForm }) => {
  const { t } = useTranslation()
  return (
    <div className="md:px-4 pt-4 max-h-[55vh] mt-10  overflow-y-auto">
      {renderForm === 5 && (
        <div className='-mt-4' >
          <p className="md:text-[16px] text-[13px] font-bold text-gray-100 pb-1 max-w-[500px]  mx-auto">

            {t(`l4-6-desc1`)}  <br />
            {t(`l4-6-desc2`)}
          </p>
          <div className="md:mt-10 mt-16">
            <CommonRadioForm list={firstSevenResources} formik={formik} />
          </div>

        </div>
      )}
      {renderForm === 6 && <CommonRadioForm list={secondSevenResources} formik={formik} />}
      {renderForm === 7 && <CommonRadioForm list={thirdSevenResources} formik={formik} />}
    </div>
  );
};

export default ResourcesFormOne;
